export default __webpack_public_path__ + "static/media/CMM-8countsheet.d49678bd.pdf";